// extracted by mini-css-extract-plugin
module.exports = {"floatingButton":"SandboxHost_floatingButton__2yLo7","sandboxDrawer":"SandboxHost_sandboxDrawer__2duG-","title":"SandboxHost_title__3Y2tC"};